import { useAlert } from "hooks/alerts/useAlert";
import { useCallback } from "react";
import { api } from "services/api.service";
import { Asset } from "types/asset";

export default function useUpdateAsset({ refetch }: { refetch: () => void }) {
  const { alertSuccess } = useAlert();

  const update = useCallback(
    (asset: Asset) =>
      api.put(`/assets/${asset.uuid}`, { asset }).then(() => {
        refetch();
        alertSuccess("Changes saved.", {
          vertical: "bottom",
          horizontal: "right",
        });
      }),
    [refetch, alertSuccess]
  );

  const pendingPickup = useCallback(
    (uuid: string) => {
      return api.put(`/assets/${uuid}/pending_pickup`).then(() => {
        refetch();
        alertSuccess("You've successfully updated the asset!", {
          vertical: "bottom",
          horizontal: "right",
        });
      });
    },
    [refetch, alertSuccess]
  );

  const unlockAsset = useCallback(
    (uuid: string) => {
      return api.put(`/assets/${uuid}`, { enrolledStatus: "unlocked" }).then(() => {
        refetch();
      });
    },
    [refetch]
  );

  const reportDamage = useCallback(
    (uuid: string, damageNotes: string) => {
      return api.put(`/assets/${uuid}`, { damageNotes }).then(() => {
        refetch();
      });
    },
    [refetch]
  );

  const notFoundAsset = useCallback(
    (uuid: string) => {
      return api.put(`/assets/${uuid}/asset_not_found`).then(() => {
        refetch();
      });
    },
    [refetch]
  );
  return {
    update,
    pendingPickup,
    unlockAsset,
    reportDamage,
    notFoundAsset,
  };
}
